<template>
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="1000" persistent>
      <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            color="success" 
            small
          >
          Editar</v-btn>
      </template>
      <template>
        <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-toolbar color="primary" class="title" tile elevation="0" dark>Editar Pessoa</v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12" class="mb-n5">
                  <v-textarea
                    v-model="formulario.nome"
                      label="Nome Completo"
                      filled
                      rows="1"
                      auto-grow
                      :rules="[v => !!v || 'Nome completo é obrigatório.']"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="mb-n5">
                  <v-textarea
                    v-model="formulario.email"
                      label="E-mail"
                      filled
                      rows="1"
                      auto-grow
                      :rules="[v => !!v || 'E-mail é obrigatório.']"
                  ></v-textarea>
                </v-col>
                <v-col cols="6" class="mb-n5">
                  <v-select
                    v-model="formulario.organizacao.id"
                    :items="organizacoes"
                    item-text="nome"
                    item-value="id"
                    filled
                    label="Selecione a organização"
                    dense
                    :rules="[v => !!v || 'Nome da Organização é obrigatório.']"
                  ></v-select>
                </v-col>
                <v-col cols="6" class="mb-n8">
                  <v-select
                    v-model="formulario.estado"
                    :items="states"
                    item-text="nome"
                    item-value="nome"
                    filled
                    label="Estado"
                    dense
                    
                  ></v-select>
                </v-col>

                <v-col cols="12" class="mb-n8">
                  <v-select
                    v-model="papelTemporario"
                    :items="papeis"
                    item-text="nome"
                    item-value="papel"
                    filled
                    label="Papel"
                    dense
                    :rules="[v => !!v || 'Papel é obrigatório.']"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-switch
                    v-model="formulario.ativo"
                    :label="`Acesso: ${formulario.ativo ? 'Ativo' : 'Inativo'}`"
                  ></v-switch>
                </v-col>
              </v-row>

            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-end py-3 mx-1">
              <v-btn color="secondary" @click.prevent="fecharELimpar">Cancelar</v-btn>
              <v-btn color="primary" type="submit"> Salvar alterações </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </template>
    </v-dialog>
</template>

<script>

import {mapActions} from "vuex";

export default {
  components: {},
  props: {
    pessoa: {
      require: false
    }
  },  
  computed: {
    organizacoes() {
      return this.$store.getters["organizacao/all"];
    }
  },
  data() {
    return {
      valid: true,
      dialog: false,
      formulario: {},
      papelTemporario: this.pessoa.authorities[0],
      papeis: [
        {papel: 'ADMINISTRADOR_SISTEMA', nome: 'Administrador(a) do Sistema'},
        {papel: "COORDENADOR_SISTEMA", nome: "Coordenador(a) do Sistema" },
        {papel: 'USUARIO', nome: 'Usuário'},
      ],
      states: [
        {sigla: 'AC', nome: 'Acre' },
        {sigla: 'AL', nome: 'Alagoas' },
        {sigla: 'AP', nome: 'Amapá' },
        {sigla: 'AM', nome: 'Amazonas' },
        {sigla: 'BA', nome: 'Bahia' },
        {sigla: 'CE', nome: 'Ceará' },
        {sigla: 'DF', nome: 'Distrito Federal' },
        {sigla: 'ES', nome: 'Espírito Santo' },
        {sigla: 'GO', nome: 'Goías' },
        {sigla: 'MA', nome: 'Maranhão' },
        {sigla: 'MT', nome: 'Mato Grosso' },
        {sigla: 'MS', nome: 'Mato Grosso do Sul' },
        {sigla: 'MG', nome: 'Minas Gerais' },
        {sigla: 'PA', nome: 'Pará' },
        {sigla: 'PB', nome: 'Paraíba' },
        {sigla: 'PR', nome: 'Paraná' },
        {sigla: 'PE', nome: 'Pernambuco' },
        {sigla: 'PI', nome: 'Piauí' },
        {sigla: 'RJ', nome: 'Rio de Janeiro' },
        {sigla: 'RN', nome: 'Rio Grande do Norte' },
        {sigla: 'RS', nome: 'Rio Grande do Sul' },
        {sigla: 'RO', nome: 'Rondônia' },
        {sigla: 'RR', nome: 'Roraíma' },
        {sigla: 'SC', nome: 'Santa Catarina' },
        {sigla: 'SP', nome: 'São Paulo' },
        {sigla: 'SE', nome: 'Sergipe' },
        {sigla: 'TO', nome: 'Tocantins' },
      ],

    };
  },
  created() {
    this.formulario = {...this.pessoa}
  },
  methods: {
    ...mapActions('usuario', ['editUsuario']),

    save() {
      if(this.$refs.form.validate()) {
        this.update().then((pessoa) => {
          this.$refs.form.resetValidation()
          this.formulario = {};
          this.$emit("save", { pessoa });
          this.fecharELimpar()
        })
         .catch((error) => {
           if (error.response) {
             this.errorMessage = error.response.data
           }
         })
      }
    },
    update() {
      this.formulario["papelTemporario"] = this.papelTemporario
      return this.editUsuario(this.formulario);
    },
    fecharELimpar() {
      this.formulario = {...this.pessoa}    
      this.dialog = false
    },
  
  },  
};
</script>
